import React from 'react';
import { Spin, Pagination, Image, Typography, Divider, Breadcrumb, Card, Carousel, Tooltip, Row, Col, Layout, Menu, Button, Input, Space } from 'antd';

import { HomeOutlined, ContainerOutlined, LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

const { Meta } = Card;

class ViewView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initData: '',
            viewPlate:{},
            loading: false
        };

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            systemConfig: this.props.systemConfig,
            title: this.props.title,
            attachment: this.props.attachment,
            video: this.props.video,
            loading: false
        })

    }


    render() {

        let views = (
                <>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item><Link to="/"><HomeOutlined /></Link></Breadcrumb.Item>
                    <Breadcrumb.Item>{this.state.title}</Breadcrumb.Item>
                </Breadcrumb>
                <Divider />
                <Row>
                    <Col xs={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                    </Col>
                    <Col xs={{ span: 11, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                        <Space align='center'>{this.state.attachment}</Space>
                    </Col>
                    <Col xs={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                    </Col>
                    <Col xs={{ span: 11, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                        <Space align='center'>{this.state.video}</Space>
                    </Col>
                    <Col xs={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 2 }}>
                    </Col>
                </Row>
                </>
        );
        return views
    }

}

export default ViewView;
